import CreatorStoriesHeroSection from "@/components/CreatorStories/CreatorStoriesHeroSection";
import FeatureCTASection from "@/components/Features/FeatureCTASection";
import { FooterDataType } from "@/components/organisms/Footer";
import GraphyHead from "@/components/organisms/GraphyHead";
import { Navbar } from "@/components/organisms/Navbar";
import { DEFAULT_COUNTRY_CODE } from "@/shared/constants/common.constants";
import {
  CreatorStoriesPageDataType,
  creatorStoriesPageData_en,
} from "@/shared/data/creator-stories.data";
import { creatorStoriesPageData_kr } from "@/shared/data/creator-stories.data.kr";
import { footerData_en, footerData_us } from "@/shared/data/footer.data";
import { footerData_kr } from "@/shared/data/footer.data.kr";
import { NavbarDataType, navbarData_en, navbarData_us } from "@/shared/data/navbar.data";
import { navbarData_kr } from "@/shared/data/navbar.data.kr";
import { useDataStore } from "@/shared/store/useDataStore";
import { GetStaticProps, InferGetStaticPropsType } from "next";
import dynamic from "next/dynamic";
import { parseCookies } from "nookies";

const Footer = dynamic(() => import("@/components/organisms/Footer"));

export const getStaticProps: GetStaticProps<{
  navbarData: NavbarDataType;
  creatorStoriesPageData: CreatorStoriesPageDataType;
  footerData: FooterDataType;
}> = async (context) => {
  const creatorStoriesPageData = {
    en: creatorStoriesPageData_en,
    us: creatorStoriesPageData_en,
    kr: creatorStoriesPageData_kr,
    in: creatorStoriesPageData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const navbarData = {
    en: navbarData_en,
    us: navbarData_us,
    kr: navbarData_kr,
    in: navbarData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const footerData = {
    en: footerData_en,
    us: footerData_us,
    kr: footerData_kr,
    in: footerData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];


  const { creatorStoriesHeroSectionProps } = creatorStoriesPageData;

  // filter successStories:
  let filteredSuccessStories =
    creatorStoriesHeroSectionProps.successStories.filter(
      (successStory) => successStory.showOn.stories
    );

  return {
    props: {
      navbarData,
      creatorStoriesPageData: {
        ...creatorStoriesPageData,
        creatorStoriesHeroSectionProps: {
          ...creatorStoriesHeroSectionProps,
          successStories: filteredSuccessStories,
        },
      },
      footerData,
    },
  };
};

export default function Product({
  navbarData,
  creatorStoriesPageData,
  footerData,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const { seoMeta, featureCTASectionProps, creatorStoriesHeroSectionProps } =
    creatorStoriesPageData;

  const cookies = parseCookies();

  const { countryCode } = useDataStore();
  const cookieCountryCode = cookies?.countryCode || DEFAULT_COUNTRY_CODE;
  const finalCountryCode = countryCode || cookieCountryCode;
  return (
    <>
      <GraphyHead {...seoMeta} countryCode={finalCountryCode} />
      <Navbar navbarData={navbarData} />
      <div className="flex flex-col gap-12 sm:gap-20">
        <CreatorStoriesHeroSection {...creatorStoriesHeroSectionProps} />
        <FeatureCTASection {...featureCTASectionProps} />
        <Footer footerData={footerData} />
      </div>
    </>
  );
}
